import { CommonAlertService } from './../../services/common-alert.service';
import { filter } from 'rxjs/operators';
import { MasterService } from './../../home/services/master.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgForm, Form } from '@angular/forms';

@Component({
  selector: 'app-regions-modal',
  templateUrl: './regions-modal.component.html',
  styleUrls: ['./regions-modal.component.scss']
})
export class RegionsModalComponent implements OnInit {
  editOb: any;
  editData: any;
  nameID: any;
  successMsg: any;
  public user = {
    name : '',
  };
  public editPermission = false;

  // tslint:disable-next-line:max-line-length
  constructor(public dialogRef: MatDialogRef<RegionsModalComponent>, public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {
    // tslint:disable-next-line:indent
  	if (data) {
      this.editOb = data.edit;
    }
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['more.regions.edit'] == 1) {
        this.editPermission = true;
      }
    }
    // tslint:disable-next-line:indent
  	 if (this.editOb) {
      this.masterService.getRecordById(this.editOb.editID, this.editOb.encryId, '/regions/get_data').subscribe(res => {
        // @ts-ignore
        this.editData = res.data;
      });
    }
  }

  close() {
    this.dialogRef.close();
  }
  submitForm(data) {

    if (this.editData) {

      // tslint:disable-next-line:variable-name max-line-length no-shadowed-variable
      const form_data = Object.assign(data, { id: this.editOb.editID }, { enc_id: this.editOb.encryId }, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, '/regions/update').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      });

    } else {
      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/regions/store').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });
    }
    this.close();
  }

}
